import React from 'react'
import { graphql } from 'gatsby'
import SEO from '~/components/seo'
import '~/styles/lookbook.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faExpand } from '@fortawesome/free-solid-svg-icons'
import Slider from '../../components/Slider'
import LookbookGrid from '../../components/LookbookGrid'

// == STYLES ==
import { Wrapper } from './style';

library.add(faExpand)

class WorkPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      fullscreenIsActive: false,
      isMenuOpen: false,
      innerHeight: 1,
      isIOSDevice: false,
      isSliderActive: true,
      selectedImage: 0,
    }
  }

  componentDidMount() {
    if (this.iOS()) {
      this.setState({ innerHeight: `${window.innerHeight}`, isIOSDevice: true })
    }
  }

  changeBackground = color => {
    this.setState({ backgroundColor: color })
  }

  enableFullscreen = () => {
    this.setState(prevState => ({
      fullscreenIsActive: !prevState.fullscreenIsActive,
    }))
  }

  handleMenuOpen = () => {
    this.setState(prevState => ({
      isMenuOpen: !prevState.isMenuOpen,
    }))
  }

  iOS = () => {
    const iDevices = ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod']

    if (navigator.platform) {
      while (iDevices.length) {
        if (navigator.platform === iDevices.pop()) {
          return true
        }
      }
    }

    return false
  }

  zoomHandler = idx => {
    this.setState({ selectedImage: idx, isSliderActive: true })
  }

  exitZoomHandler = () => {
    this.setState({ selectedImage: 0, isSliderActive: false })
  }

  render() {
    const {
      backgroundColor,
      fullscreenIsActive,
      isMenuOpen,
      isIOSDevice,
      innerHeight,
      isSliderActive,
      selectedImage,
    } = this.state
    const style = isIOSDevice ? { height: `${innerHeight}px` } : {}
    const {
      data: {
        pageData: {
          frontmatter: { seo_title, seo_description, images, title },
        },
      },
    } = this.props

    return (
      <>
        <SEO title={seo_title} description={seo_description} />
        <Wrapper>
          {isSliderActive ? (
            <Slider images={images} selected={selectedImage} exitZoomHandler={this.exitZoomHandler} />
          ) : (
            <LookbookGrid images={images} title={title} zoomHandler={this.zoomHandler} />
          )}
        </Wrapper>
      </>
    )
  }
}

export const query = graphql`
  query($slug: String) {
    pageData: markdownRemark(fields: { slug: { eq: $slug } }) {
      frontmatter {
        seo_title
        seo_description
        title
        images {
          description
          altText
          image 
        }
      }
    }
  }
`

export default WorkPage
